import React from "react";
import "./styles.scss";
import { FormCheck, RadioButton } from "..";

const Index = ({ data, onClick }) => {
  let inputElement = null;

  inputElement = (
    <>
      <div
        className={`radio-button-wrapper ${
          data.isActive ? "active-me " : "default"
        }`}
        onClick={onClick}
      >
        <div className={"rbw__check-wrapper"}>
          <div className={"rbw__cw-check"}></div>
        </div>
        <div className={"rbw__name"}>{data.name}</div>
      </div>
    </>
  );

  return <>{inputElement}</>;
};
Index.propTypes = {};

Index.defaultProps = {};
export default Index;
